import { render } from "./DForm.vue?vue&type=template&id=6cf29bfa"
import script from "./DForm.vue?vue&type=script&lang=ts"
export * from "./DForm.vue?vue&type=script&lang=ts"
script.render = render

export default script